import React from "react";
import {useLocation} from "react-router-dom";
import {MENU_LEFT} from "../../../shared/routes/constants";
import {AccordionItem} from "./item";
import {Export} from "./export";
import {Delete} from "./delete";
import {Report} from "./report";
import {AnnotateSlide} from "./AnnotateSlide";

const Items = () => {
    const location = useLocation();
    const isViewPage = location.pathname.startsWith('/view');

    return (
        <div className={"accordion"}>
            {MENU_LEFT.map((item, index) => (
                <AccordionItem key={`menu_item_${index}`}
                               title={item.title}
                               info={item.isInfo}
                >{item.content}</AccordionItem>
            ))}
            <AccordionItem title={'Экспорт'} info={false}><Export/></AccordionItem>
            <AccordionItem title={'Отчет'} info={false}><Report/></AccordionItem>
            <AccordionItem title={'Удаление'} info={false}><Delete/></AccordionItem>
            {isViewPage && (
                <AccordionItem title={'Разметка'} info={false} defaultOpen={true}>
                    <AnnotateSlide/>
                </AccordionItem>
            )}
        </div>
    )
};

export default Items;
